import EditOrderOption from "./EditOrderOption";
import PropTypes from "prop-types";
import { getOrderedDishOption } from "../../../../utils/model/userOrder";


const EditOrderOptions = ({options, selectedOptions, onChange}) => {
    const handleOptionsChange = (value, id) => {
        const newSelectedOptions = selectedOptions
            .filter((option) => option.id && option.id !== id)
            .concat({id, value});
        onChange(newSelectedOptions);
    }
    return options.map((option) => (
        <EditOrderOption
            key={`edit-order-option-${option.id}`}
            option={option}
            selectedOption={getOrderedDishOption(selectedOptions, option.id)}
            onChange={handleOptionsChange}
        />
    ));
}

EditOrderOptions.propTypes = {
    options: PropTypes.array.isRequired,
    selectedOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
}

export default EditOrderOptions;
